<template>
  <div class="page-content">
    <h1>{{ pageContent.title }}</h1>
    <a class="back-button" @click="$router.go(-1)"> Back </a>
    <div class="page-content-content" v-html="pageContent.content">
    </div>
  </div>
</template>

<script>
export default {
  title () {
    return 'Page'
  },
  props: ['handle'],
  computed: {
    pages () {
      if (this.$root.pageContent) {
        return this.$root.pageContent
      } else {
        return []
      }
    },
    pageContent () {
      console.log(this.handle)
      var pageContent = this.pages.find(o => o.handle === this.handle)
      console.log(pageContent)
      if (typeof pageContent !== 'undefined') {
        return pageContent
      } else {
        return false
      }
    }
  }
}
</script>
